import { render } from "./RequestCrypto.vue?vue&type=template&id=31b58863"
import script from "./RequestCrypto.vue?vue&type=script&lang=js"
export * from "./RequestCrypto.vue?vue&type=script&lang=js"
script.render = render

export default script